export const editorMoveObjectForward = () => {
  const selection = window.canvas.getActiveObject();

  if (!selection) {
    throw new Error('No objects selected');
  }

  selection.bringForward();
  window.canvas.renderAll();
};
